import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './KitDeMarcaFullPage.css';
import './MobileNav.css';
import logo from '../assets/logoblanco-def.png';
import favicon from '../assets/favicon.png';
import { useCart } from '../context/CartContext';
import { useNavbarScroll } from '../hooks/useNavbarScroll';
import MobileNav from './MobileNav';
import winecurv01 from '../assets/winecurv_15_1-Convertido-01.png';
import winecurv02 from '../assets/winecurv_15_1-Convertido-02.png';
import winecurv06 from '../assets/winecurv_15_1-Convertido-06.png';
import winecurv18 from '../assets/winecurv_15_1-Convertido-18.png';
import winecurv22 from '../assets/winecurv_15_1-Convertido-22.png';
import winecurv25 from '../assets/winecurv_15_1-Convertido-25.png';
import winecurv04 from '../assets/winecurv_15_1-Convertido-04.png';
import winecurv17 from '../assets/winecurv_15_1-Convertido-17.png';
import winecurv24 from '../assets/winecurv_15_1-Convertido-24.png';
import winecurv05 from '../assets/winecurv_15_1-Convertido-05.png';
import winecurv14 from '../assets/winecurv_15_1-Convertido-14.png';
import winecurv27 from '../assets/winecurv_15_1-Convertido-27.png';

/** Archivos del kit: poné los que tengas en public/kit-marca/ */
const KIT_MARCA_ARCHIVOS = [
  { label: 'Logo principal (PNG)', file: 'kit-marca/logo-principal.png' },
  { label: 'Logo principal (SVG)', file: 'kit-marca/logo-principal.svg' },
  { label: 'Logo blanco (PNG)', file: 'kit-marca/logo-blanco.png' },
  { label: 'Guía de marca (PDF)', file: 'kit-marca/guia-marca.pdf' },
];

const KitDeMarcaFullPage = () => {
  const navigate = useNavigate();
  const { toggleCart, getTotalItems } = useCart();
  const [navReady, setNavReady] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { hidden: navbarHidden, compact: navbarCompact } = useNavbarScroll();

  useEffect(() => {
    window.scrollTo(0, 0);
    const t = setTimeout(() => setNavReady(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="kit-full-page">
      <img src={winecurv01} alt="" className="kit-fp-decor kit-fp-decor-1" />
      <img src={winecurv02} alt="" className="kit-fp-decor kit-fp-decor-2" />
      <img src={winecurv06} alt="" className="kit-fp-decor kit-fp-decor-3" />
      <img src={winecurv18} alt="" className="kit-fp-decor kit-fp-decor-4" />
      <img src={winecurv22} alt="" className="kit-fp-decor kit-fp-decor-5" />
      <img src={winecurv25} alt="" className="kit-fp-decor kit-fp-decor-6" />
      <img src={winecurv04} alt="" className="kit-fp-decor kit-fp-decor-7" />
      <img src={winecurv17} alt="" className="kit-fp-decor kit-fp-decor-8" />
      <img src={winecurv24} alt="" className="kit-fp-decor kit-fp-decor-9" />
      <img src={winecurv05} alt="" className="kit-fp-decor kit-fp-decor-10" />
      <img src={winecurv14} alt="" className="kit-fp-decor kit-fp-decor-11" />
      <img src={winecurv27} alt="" className="kit-fp-decor kit-fp-decor-12" />

      <nav className={`kit-fp-navbar${navReady ? ' kit-fp-nav-ready' : ''}${navbarHidden ? ' navbar-hidden' : ''}${navbarCompact ? ' navbar-compact' : ''}`}>
        <div className="kit-fp-navbar-content">
          <div className="kit-fp-nav-left">
            <button onClick={() => navigate('/')} className="kit-fp-nav-link">INICIO</button>
            <button onClick={() => navigate('/equipo')} className="kit-fp-nav-link">EQUIPO</button>
            <button onClick={() => navigate('/bodegas')} className="kit-fp-nav-link">BODEGAS</button>
            
          </div>
          <div className="kit-fp-nav-center">
            <button onClick={() => navigate('/')}>
              <img src={logo} alt="Rosés Wines" className="kit-fp-nav-logo" />
            </button>
          </div>
          <div className="kit-fp-nav-right">
            <button onClick={() => navigate('/historia')} className="kit-fp-nav-link">HISTORIA</button>
            <button onClick={() => navigate('/kit-de-marca')} className="kit-fp-nav-link">KIT DE MARCA</button>
            <button onClick={() => navigate('/#tienda')} className="kit-fp-nav-link">TIENDA</button>
            <button className="kit-fp-nav-link kit-fp-cart" onClick={toggleCart}>
              <span className="cart-icon">🛒</span>
              {getTotalItems() > 0 && (
                <span className="kit-fp-cart-badge">{getTotalItems()}</span>
              )}
            </button>
          </div>
          <button
            type="button"
            className={`mobile-nav-hamburger${mobileMenuOpen ? ' open' : ''}`}
            onClick={() => setMobileMenuOpen((o) => !o)}
            aria-expanded={mobileMenuOpen}
            aria-label="Menú"
          >
            <span className="mobile-nav-hamburger-line" />
            <span className="mobile-nav-hamburger-line" />
            <span className="mobile-nav-hamburger-line" />
          </button>
        </div>
      </nav>

      <MobileNav open={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} />

      <section className="kit-fp-hero">
        <div className="kit-fp-hero-icon">
          <img src={favicon} alt="" />
        </div>
        <h1 className="kit-fp-hero-title">KIT DE MARCA</h1>
        <p className="kit-fp-hero-subtitle">
          Recursos de marca para partners, prensa y colaboradores.
        </p>
        <button className="kit-fp-scroll-indicator" onClick={() => document.getElementById('kit-content')?.scrollIntoView({ behavior: 'smooth' })} aria-label="Bajar">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 5v14M19 12l-7 7-7-7" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </section>

      <section id="kit-content" className="kit-fp-content">
        <div className="kit-fp-content-inner">
          <div className="kit-fp-icon-wrap">
            <img src={favicon} alt="" className="kit-fp-content-icon" />
          </div>
          <h2 className="kit-fp-content-title">Identidad Rosés Wines</h2>
          <p className="kit-fp-content-text">
            Nuestra identidad de marca refleja la tradición y la calidad de Bodega Rosés. Elegí los archivos que necesites y descargalos.
          </p>
          <p className="kit-fp-content-text">
            Si necesitás algo que no está acá, escribinos a <a href="mailto:roses@bodegasoses.com.uy" className="kit-fp-link">roses@bodegasoses.com.uy</a>.
          </p>
          <div className="kit-fp-files">
            {KIT_MARCA_ARCHIVOS.map((item) => {
              const url = `${process.env.PUBLIC_URL || ''}/${item.file}`;
              const fileName = item.file.split('/').pop();
              return (
                <a
                  key={item.file}
                  href={url}
                  download={fileName}
                  className="kit-fp-file-link"
                >
                  <span className="kit-fp-file-label">{item.label}</span>
                  <span className="kit-fp-file-dl">Descargar</span>
                </a>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default KitDeMarcaFullPage;
